import { useGetTherapistEnrollments } from "api/services/therapist/hooks";
import { EnrolledPatients } from "routes/dashboard/default/components/shared/EnrolledPatients";

export const Enrollments: React.FC = () => {
  const { data: enrollmentsData } = useGetTherapistEnrollments();

  if (enrollmentsData?.enrollment_goal === undefined || enrollmentsData?.enrollment_goal === 0) {
    return null;
  }

  return (
    <EnrolledPatients
      enrollmentGoal={enrollmentsData?.enrollment_goal}
      patientsEnrolled={enrollmentsData?.patients_enrolled}
    />
  );
};
